import React from 'react';

import { useStockCarsTabs } from '@/modules/CarsStock/components/common.hooks';
import StockTabs from '@/components/StockTabs';

import { TabsProps } from './types';

function Tabs({ carsType }: TabsProps) {
  const { activeTab, tabs } = useStockCarsTabs(carsType);

  if (!tabs || tabs.length === 0) {
    return null;
  }

  return <StockTabs activeTab={activeTab} tabs={tabs} />;
}

export default Tabs;
